import React from 'react';
import { Reveal } from './Reveal';
import { TrendingUp, Database, ShieldCheck } from 'lucide-react';

export const WhyNow = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16">
      <Reveal>
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="text-[10px] uppercase tracking-[0.22em] text-[#39FF14]">// the macro thesis</span>
            <h2 className="display text-3xl md:text-4xl font-semibold mt-2 leading-tight">
              The next decade of revenue is <span className="gradient-text">agentic</span> — and the window is open <em>now</em>.
            </h2>
            <p className="text-white/65 mt-4 max-w-md text-sm md:text-base">
              Frontier LLMs just crossed the threshold where agents can credibly run revenue workflows end-to-end — outbound, ops, support, finance. The teams that operationalize this in 2026 will compound a structural advantage their competitors won’t catch.
            </p>
            <p className="text-white/65 mt-3 max-w-md text-sm md:text-base">
              RevCore is the OS for that shift: a curated marketplace, a 60-second no-code builder, multi-model routing, and a unit-economic margin that improves with every model release.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
            {[
              { icon: TrendingUp, label: 'Market', stat: '$520B', sub: 'agentic AI TAM by 2030 (BCG estimate)', color: '#FF6B1A' },
              { icon: Database, label: 'Tailwind', stat: '8×', sub: 'frontier model capability since 2024 — prices down 65%', color: '#39FF14' },
              { icon: ShieldCheck, label: 'Moat', stat: '18 + N', sub: 'curated agents + every fork compounds our prompt graph', color: '#FFB17A' },
              { icon: TrendingUp, label: 'Wedge', stat: 'Revenue', sub: 'every agent is tuned for a measurable revenue outcome', color: '#39FF14' },
            ].map((m) => (
              <div key={m.label} className="card-base card-hover p-5">
                <div className="h-9 w-9 rounded-xl grid place-items-center hairline mb-3" style={{ boxShadow: `0 0 18px ${m.color}33` }}>
                  <m.icon className="h-4 w-4" style={{ color: m.color }} />
                </div>
                <div className="text-[10px] uppercase tracking-widest text-white/45">{m.label}</div>
                <div className="display text-2xl md:text-3xl font-semibold mt-1">{m.stat}</div>
                <p className="text-xs text-white/60 mt-1">{m.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
